export default "__VITE_ASSET__dT0dfs19__"